import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Add a loading state
    const navigate = useNavigate();

    const verifyToken = async (token) => {
        try {
            // Call your backend to verify the token
            await axios.get("https://ekhoni-khabo-server.vercel.app/api/v1/auth/verify-token", {
                // await axios.get("https://ekhoni-khabo-server.vercel.app/api/v1/auth/verify-token", {
                headers: { Authorization: `Bearer ${token}` },
            });
            return true;
        } catch (err) {
            console.error("Invalid token:", err);
            return false;
        }
    };

    useEffect(() => {
        const checkToken = async () => {
            const token = localStorage.getItem("authToken");
            const firstName = localStorage.getItem("firstName");
            const lastName = localStorage.getItem("lastName");
            const role = localStorage.getItem("role");
            if (token) {
                const isValid = await verifyToken(token);
                if (isValid) {
                    setUser({ token, firstName, lastName, role });
                } else {
                    localStorage.removeItem("authToken");
                    localStorage.removeItem("firstName");
                    localStorage.removeItem("lastName");
                    localStorage.removeItem("role");
                    navigate("/login");
                }
            }
            setLoading(false);
        };
        checkToken();
    }, [navigate]);


    const login = async (email, password) => {
        try {
            const response = await axios.post("https://ekhoni-khabo-server.vercel.app/api/v1/auth/login", {
                // const response = await axios.post("https://ekhoni-khabo-server.vercel.app/api/v1/auth/login", {
                email,
                password,
            });
            const { token, firstName, lastName, role } = response.data;
            // console.log(response.data)
            localStorage.setItem("authToken", token);
            localStorage.setItem("firstName", firstName);
            localStorage.setItem("lastName", lastName);
            localStorage.setItem("role", role)

            setUser({ token, firstName, lastName, role });
            // console.log(user)
            navigate("/");
        } catch (err) {
            console.error("Login error:", err);
            alert("Invalid email or password");
        }
    };

    const register = async (userData) => {
        try {
            await axios.post("https://ekhoni-khabo-server.vercel.app/api/v1/auth/register", userData);
            alert("Registration Successful. Please Login.");
            navigate("/login");
        } catch (err) {
            alert(err.response.data);
        }
    };

    const logout = () => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("firstName");
        localStorage.removeItem("lastName");
        localStorage.removeItem("role")
        setUser(null);
        navigate("/login");
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
